import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { colors } from '../../assets/utils/colors';
import { Chip, Typography } from '@mui/material';
import { slice, map, size } from 'lodash';
import { getChipColor, numberWithCommas } from '../../utils/helpers';
import { useSelector } from 'react-redux';

const columns = [
  {
    id: 's_n',
    label: 'S/N',
    align: 'center',
    fontWeight: 'bold',
    width: 10,
  },
  {
    id: 'order_id',
    label: 'OrderID',
  },
  {
    id: 'deliver_opt',
    label: 'DeliveryOPT',
  },
  {
    id: 'pick_up',
    label: 'Pick-up Address',
  },
  {
    id: 'amount',
    label: (
      <Typography sx={{ fontSize: 14, fontWeight: 'bold' }}>
        Amount <sup style={{ color: 'green' }}>TZS</sup>
      </Typography>
    ),
  },
  {
    id: 'status',
    label: 'Status',
  },
  // {
  //     id: 'action',
  //     label: 'Action',
  // },
];

const createData = (
  s_n,
  order_id,
  deliver_opt,
  pick_up,
  amount,
  status,
  action
) => {
  return { s_n, order_id, deliver_opt, pick_up, amount, status, action };
};

export default function CustomerOrdersTable() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const orders = useSelector((state) => state.users.customerOrders);

  const orderRows = map(orders, (order, index) =>
    createData(
      index + 1,
      order.order_number,
      order.delivery_type === 'self_pickup' ? 'Self pick-up' : 'Door delivery',
      order.pickup_branch ? order.pickup_branch : 'unavailable',
      numberWithCommas(order.total_amount),
      <Chip
        sx={{
          textTransform: 'capitalize',
        }}
        label={order.order_status}
        size="small"
        color={getChipColor(order.order_status)}
      />
    )
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ height: 550, m: 0 }}>
        <Table
          stickyHeader
          aria-label="sticky table"
          sx={{
            '& th': {
              bgcolor: `${colors.bgColor1} !important`,
            },
          }}
        >
          <TableHead>
            <TableRow>
              {map(columns, (column) => (
                <TableCell
                  key={column.id}
                  sx={{
                    fontWeight: 'bold',
                    color: colors.primary,
                    textAlign: column.align,
                    width: column.width,
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {slice(
              orderRows,
              page * rowsPerPage,
              page * rowsPerPage + rowsPerPage
            ).map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        sx={{
                          fontWeight: column.fontWeight,
                        }}
                      >
                        {column.format && typeof value === 'number'
                          ? column.format(value)
                          : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        sx={{
          '&.MuiTablePagination-root': {
            bgcolor: `${colors.bgColor2} !important`,
          },
        }}
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={size(orderRows)}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
